<template>
    <returnButton />
    <div class="main-container" v-for="(item, index) in offices" :key="index">
        <div class="title-header">
            <h1 class="title">Sucursal {{ item.suc_data }}</h1>
        </div>
        <div class="content-container">
            <div class="table-container">
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th>Office Code</th>
                            <th>Dirección</th>
                            <th>Internal Id</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(office, i) in item.offices" :key="i">
                            <td>{{ office.office_code }}</td>
                            <td style="min-width: 30rem">
                                {{ office.location_address ?? 'Sin dirección' }}
                            </td>
                            <td>{{ office.internal_id }}</td>
                            <td>
                                <button
                                    @click="
                                        openModalOffice(office, item.suc_data)
                                    "
                                    class="boton-principal mr-2">
                                    Actualizar Informacion
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <v-dialog v-model="showModal" persistent max-width="600px">
            <v-row justify="center">
                <v-card class="h-50 min-w-25">
                    <i
                        class="mdi mdi-close-circle boton-cerrar-x"
                        style="
                            position: absolute;
                            top: 10px;
                            right: 10px;
                            float: right;
                            font-size: 25px;
                            cursor: pointer;
                            color: white;
                        "
                        @click="closeModalOffice()"></i>
                    <v-card-title>
                        Oficina {{ selectedOfficeName }} Noº
                        {{ selectedOffice.internal_id }}
                    </v-card-title>
                    <v-card-text class="text-center trebuchet mt-3">
                        ¿Estás seguro que quieres actualizar esta sucursal? Esta
                        accion no puede deshacerse.
                        <v-row>
                            <v-text-field
                                v-model="address"
                                label="Dirección"
                                variant="outlined"
                                density="compact"
                                class="ma-0 pa-0"
                                hide-details></v-text-field>
                        </v-row>
                        <v-row>
                            <span
                                ><b>Código Actual: </b> {{ code }}</span
                            ></v-row
                        >
                        <v-row
                            class="d-flex justify-space-between align-center">
                            <span><b>Código Nuevo: </b> {{ newCode }}</span>

                            <button
                                class="boton-refrescar rounded-full"
                                icon
                                @click="refreshCode()">
                                <v-icon>mdi-refresh</v-icon>
                            </button>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <button
                            class="boton-principal"
                            @click="
                                editOffice(selectedOffice, address, newCode)
                            ">
                            Actualizar
                        </button>
                    </v-card-actions>
                </v-card>
            </v-row>
        </v-dialog>
    </div>
</template>

<script>
import returnButton from '@/components/global/return-button.vue';
import { getAllOffice, putOfficeKey } from '@/api/location';

export default {
    components: {
        returnButton,
    },
    data() {
        return {
            offices: [],
            showModal: false,
            selectedOffice: null,
            selectedOfficeName: '',
            code: '',
            newCode: '',
            address: '',
            allOfficeCodes: [],
        };
    },
    mounted() {
        this.loadOffices();
    },
    methods: {
        async loadOffices() {
            try {
                const data = await getAllOffice();
                this.allOfficeCodes = data.map((item) => item.office_code);
                this.offices = data.reduce((acc, item) => {
                    const id = item.sucursal_id;

                    if (!acc[id]) {
                        acc[id] = {
                            sucursal_id: id,
                            suc_data: item.suc_data,
                            offices: [],
                        };
                    }

                    acc[id].offices.push({
                        id: item._key,
                        office_code: item.office_code,
                        internal_id: item.internal_id,
                        location_address: item.location_address,
                    });

                    return acc;
                }, {});
                Object.values(this.offices).forEach((group) => {
                    group.offices.sort((a, b) => {
                        const x = Number(a.internal_id) || 0;
                        const y = Number(b.internal_id) || 0;
                        return x - y;
                    });
                });
            } catch (error) {
                console.error('Error al obtener oficinas:', error);
            }
        },
        generateCode() {
            return String(Math.floor(Math.random() * 1000000)).padStart(6, '0');
        },
        refreshCode() {
            let temporalCode;

            do {
                temporalCode = this.generateCode();
            } while (this.allOfficeCodes.includes(temporalCode));

            this.newCode = temporalCode;
        },
        openModalOffice(office, officeName) {
            this.selectedOfficeName = officeName;
            this.selectedOffice = office;
            this.code = office.office_code;
            this.address = office.location_address;
            this.showModal = true;
        },
        closeModalOffice() {
            this.showModal = false;
            this.selectedOffice = '';
            this.newCode = '';
        },
        async editOffice(item, address, code) {
            const data = { id: item.id };

            if (item.location_address?.trim() !== address?.trim()) {
                data.location_address = address.trim() === '' ? null : address;
            }

            if (code?.trim() && item.office_code !== code) {
                data.office_code = code;
            }

            if (!('office_code' in data) && !('location_address' in data)) {
                this.closeModalOffice();
                return;
            }
            try {
                await putOfficeKey(data);
            } catch (error) {
                console.error(
                    'No se pudo actualizar la oficina:',
                    error.message,
                );
            }

            this.closeModalOffice();

            await this.loadOffices();
        },
    },
};
</script>

<style scoped>
.v-card {
    position: relative;
}
.v-btn {
    position: absolute;
    top: 8px;
    right: 8px;
}

.card-title-header {
    background-color: var(--aguamarina-tropical);
    top: 0;
    width: 100%;
    border-radius: 30px 30px 0 0;
}

.card-content-container {
    border-radius: 30px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    align-items: center;
    justify-content: space-between;
}

.table-container {
    padding: 1px;
    overflow-x: auto;
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    font-family: Arial, sans-serif;
}

.custom-table th {
    background-color: #fafafa;
    padding: 10px;
    font-weight: bold;
    border-bottom: 2px solid var(--aguamarina-tropical);
}

.custom-table td {
    padding: 10px;
    border-bottom: 1px solid #eee;
}

.custom-table tr:hover {
    background-color: #fafafa;
}

.boton-refrescar {
    font-family: var(--font-body);
    color: #fff;
    background-color: var(--aguamarina-tropical);
    border-radius: 50%;
    padding: 2px;
}
</style>
